import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';

export function Anff(props) {
    const group = useRef();
    const { nodes } = useGLTF('3ds/an/Anff.gltf');
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                name="Anff"
                geometry={nodes.Anff.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/Anff.gltf')